import Vue from 'vue'
import App from './App.vue'
import home from './views/home.vue'
import ElementUI from 'element-ui'
import VueSmoothScroll from 'vue2-smooth-scroll'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueSmoothScroll)
// Vue.prototype.BASE_URL = 'https://www.aierseeyou.com/ar_api'
Vue.prototype.BASE_URL = 'https://shengshimei.top/ar_api'
// Vue.prototype.BASE_URL = "http://localhost:10005"

new Vue({
  render: h => h(home)
}).$mount('#app')
